<!-- TODO: To be extended to support type info|success|etc. -->

<script setup lang="ts">
import type { AlertProps } from '#ui/types';

type MessageType = 'error' | 'info';
type TypeStyle = { color: AlertProps['color']; icon: string };

// PROPS
interface Props {
    type: MessageType;
    title: string;
    description?: string;
    actions?: AlertProps['actions'];
}

const { type } = defineProps<Props>();

const styles: Record<MessageType, TypeStyle> = {
    error: {
        color: 'error',
        icon: 'lucide:circle-x',
    },
    info: {
        color: 'primary',
        icon: 'lucide:info',
    },
};

const style = computed(() => styles[type]);
</script>

<template>
    <UAlert :icon="style.icon" :color="style.color" variant="soft" v-bind="{ title, description, actions }" />
</template>
